<template>
  <div class="myIntegralOrder">
    <ul class="orderList" v-if="orderList">
      <li class="orderTitle">
        <div class="titleColum1">积分订单</div>
        <div class="titleColum2">积分变化</div>
        <div class="titleColum3">日期</div>
        <div class="titleColum4">订单状态</div>
        <div class="titleColum5">全部</div>
      </li>
      <li class="ifNull" v-if="orderList.length===0"><p style="text-align:center;width:100%;color:#999;">此项目下无订单</p></li>
      <li
        class="orderContent"
        v-for="(item, index) in orderList"
        :key="index"
      >
        <div class="titleColum11">
          <img :src="item.thumbnailUrl" :alt="item.commodityName"/>
          <div style="width: 273px;">
            <h4>{{item.commodityName}} x{{item.count}}</h4>
            <p class="titleColum111">地址：{{item.receiveGoodsPerson}} {{item.receiveGoodsPhone}} {{item.orderAddress}}</p>
            <p class="titleColum112">订单号：{{item.orderCode}}</p>
            <p class="titleColum112">物流编号: {{item.logisticsCode === ''? '暂无' : item.logisticsCode}}</p>
          </div>
        </div>
        <div :class="item.integral > 0?'red':'green'" class="titleColum2">{{item.integral}}</div>
        <div class="titleColum3">{{item.createTime}}</div>
        <div class="titleColum4">
          {{item.status === '0'?'未受理':''}}
          {{item.status === '1'?'已受理':''}}
          {{item.status === '2'?'已发货':''}}
          {{item.status === '3'?'已取消':''}}
          {{item.status === '4'?'已收货':''}}
          {{item.status === '5'?'已结束':''}}
        </div>
        <div style="display: flex;flex-direction: column;justify-content: center;line-height: 36px;">
          <div @click="cancelOrder(item)" class="titleColum5">取消订单</div>
          <div v-if="item.status==='2'" @click="endOrder(item)" class="titleColum5">确认收货</div>
        </div>
      </li>
    </ul>
    <div class="doclist-pagination" v-if="orderList">
      <div class="doclist-lastpage" @click="jumpLastPage">上一页</div>
      <div class="doclist-omit">{{lastOmit}}</div>
      <ul>
        <li :class="item === currentPage?'pageactive':'pageDeavtive'" v-for="(item, index) in pageList" :key="index" @click="changePageTo(item)">{{item}}</li>
      </ul>
      <div class="doclist-omit">{{nextOmit}}</div>
      <div class="doclist-nextpage" @click="jumpNextPage">下一页</div>
      <div class="doclist-pagejump">共{{totalPage}}页，到第<input type="text" v-model.number="jumpTargetPage">页</div>
      <div class="doclist-jump" @click="jumpFarPage">确定</div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      orderList: null,
      // 分页
      currentPage: 1, // 当前页
      totalPage: 4, // 总页数
      lastOmit: '',
      nextOmit: '...',
      pageList: [1, 2, 3, 4, 5],
      jumpTargetPage: 1 // 跳转页
    }
  },
  methods: {
    cancelOrder (item) {
      if (item.status === '0') {
        let addScore = Math.abs(parseInt(item.integral))
        this.$http.post(`/front/train/forum/integralOrder/cancelOrder`, {
          id: item.id,
          count: item.count,
          needIntegral: addScore
        })
          .then(({ data }) => {
            console.log(data, 'cancelOrder')
            if (data.code === 0) {
              this.$message.success('取消订单成功')
              this.getOrderList()
              this.$emit('childByValue', '222')
            } else {
              // this.$message.error(data.result.msg)
            }
          })
          .catch(() => {
            // this.$message.error(error.response.data.message)
          })
      } else if (item.status === '1') {
        this.$message.warning('已受理的订单无法取消')
      } else if (item.status === '2') {
        this.$message.warning('已发货的订单无法取消')
      } else if (item.status === '3') {
        this.$message.warning('已取消的订单无法重复取消')
      } else if (item.status === '4') {
        this.$message.warning('已收获的订单无法取消')
      } else if (item.status === '5') {
        this.$message.warning('已结束的订单无法取消')
      }
    },
    endOrder (item) {
      if (item.status === '2') {
        this.$http.post(`/help/train/forum/integralOrder/completeOrder`, {
          id: item.id
        })
          .then(({ data }) => {
            console.log(data, 'endOrder')
            if (data.code === 0) {
              this.$message.success('确认收货成功')
              this.getOrderList()
              this.$emit('childByValue', '222')
            } else {
              // this.$message.error(data.result.msg)
            }
          })
          .catch(() => {
            // this.$message.error(error.response.data.message)
          })
      }
    },
    // 上一页
    jumpLastPage () {
      if (this.currentPage > 1) {
        var newCurrent = this.currentPage - 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是第一页啦')
      }
    },
    //  下一页
    jumpNextPage () {
      if (this.currentPage < this.totalPage) {
        var newCurrent = this.currentPage + 1
        this.changePageTo(newCurrent)
      } else {
        this.$message.info('这已经是最后一页啦')
      }
    },
    //   第几页
    changePageTo (page) {
      window.scrollTo(0, 0)
      if (this.totalPage > 5) {
        if (page > 2 && page < this.totalPage - 1) {
          var newPageList = []
          for (let index = page - 2; index < page + 3; index++) {
            newPageList.push(index)
          }
          this.pageList = newPageList
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = '...'
        } else if (page <= 2) {
          this.pageList = [1, 2, 3, 4, 5]
          this.currentPage = page
          this.lastOmit = ''
          if (page >= this.totalPage - 2) {
            this.nextOmit = ''
          } else {
            this.nextOmit = '...'
          }
        } else {
          var newPageList2 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
          this.pageList = newPageList2
          this.currentPage = page
          this.lastOmit = '...'
          this.nextOmit = ''
        }
      } else {
        var newPageList5 = []
        for (let index = 1; index <= this.totalPage; index++) {
          newPageList5.push(index)
        }
        this.pageList = newPageList5
        this.lastOmit = ''
        this.nextOmit = ''
        this.currentPage = page
      }
      this.getOrderList()
    },
    //   确定跳转到哪页
    jumpFarPage () {
      if (this.jumpTargetPage >= 1 && this.jumpTargetPage <= this.totalPage) {
        if (this.totalPage > 5) {
          if (this.jumpTargetPage > 2 && this.jumpTargetPage < this.totalPage - 4) {
            var newPageList3 = []
            for (let index = this.jumpTargetPage - 2; index < this.jumpTargetPage + 3; index++) {
              newPageList3.push(index)
            }
            this.pageList = newPageList3
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = '...'
          } else if (this.jumpTargetPage <= 2) {
            this.pageList = [1, 2, 3, 4, 5]
            this.currentPage = this.jumpTargetPage
            this.lastOmit = ''
            if (this.jumpTargetPage > this.totalPage - 3) {
              this.nextOmit = ''
            } else {
              this.nextOmit = '...'
            }
          } else {
            var newPageList4 = [this.totalPage - 4, this.totalPage - 3, this.totalPage - 2, this.totalPage - 1, this.totalPage]
            this.pageList = newPageList4
            this.currentPage = this.jumpTargetPage
            this.lastOmit = '...'
            this.nextOmit = ''
          }
        } else {
          var newPageList5 = []
          for (let index = 1; index <= this.totalPage; index++) {
            newPageList5.push(index)
          }
          this.pageList = newPageList5
          this.lastOmit = ''
          this.nextOmit = ''
          this.currentPage = this.jumpTargetPage
        }
        this.getOrderList()
      } else {
        this.$message.error('请输入正确的页码')
      }
    },
    getOrderList () {
      this.$http.post(`/front/train/forum/integralOrder/myOrderList`, {
        page: this.currentPage,
        limit: 10
      })
        .then(({ data }) => {
          console.log(data, 'getOrderList')
          if (data.code === 0) {
            this.orderList = data.data.data || []
            this.totalPage = Math.ceil(data.data.count / 10)
            let newPageList = []
            if (this.totalPage <= 5) {
              for (let i = 1; i <= this.totalPage; i++) {
                newPageList.push(i)
              }
              this.pageList = newPageList
              this.nextOmit = ''
            }
          }
        })
        .catch(() => {
          // this.$message.error(error.response.data.message)
        })
    }
  },
  created () {
    this.getOrderList()
  }
}
</script>

<style scoped>
.myIntegralOrder{
  width: 1190px;
  background: #ffffff;
  padding-bottom: 30px;
}
/* 积分订单列表样式 */
.orderList li{
  display: flex;
}
.orderTitle{
  background: #eeeeee;
  height: 60px;
  line-height: 60px;
  font-size: 18px;
  color: #999999;
}
.titleColum1{
  width: 432px;
  text-align: center;
}
.titleColum2{
  width: 126px;
  text-align: center;
}
.titleColum3{
  width: 292px;
  text-align: center;
}
.titleColum4{
  width: 154px;
  text-align: center;
}
.titleColum5{
  width: 186px;
  padding-left: 16px;
  text-align: center;
  user-select: none;
  cursor: pointer;
}
.orderContent{
  height: 183px;
  line-height: 176px;
  font-size: 16px;
  color: #333333;
  border-bottom: 1px solid #eeeeee;
}
.titleColum11{
  width: 432px;
  padding-top: 33px;
  padding-left: 30px;
  display: flex;
}
.titleColum11 img{
  width: 80px;
  height: 80px;
  margin-right: 18px;
}
.titleColum11 h4{
  margin: 0;
  height: 24px;
  line-height: 20px;
  font-size: 14px;
  color: #262626;
  font-weight: normal;
  overflow: hidden;
  word-break:break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.titleColum111{
  height: 40px;
  line-height: 20px;
  font-size: 14px;
  color: #666666;
  font-weight: normal;
  overflow: hidden;
  word-break:break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 0;
  margin-top: 8px;
}
.titleColum112{
  height: 20px;
  line-height: 20px;
  font-size: 14px;
  color: #999999;
  margin-top: 8px;
}
/* 分页区域样式 */
.doclist-pagination .pageactive{
  background: #1D65A8;
  color: #ffffff;
  border: 0;
}
.doclist-pagination{
  margin-top: 30px;
  display: flex;
  height: 40px;
  line-height: 40px;
  text-align: center;
  /* padding-left: 235px; */
}
.doclist-pagination ul{
  display: flex;
}
.doclist-pagination ul li{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
  cursor: pointer;
  border: 1px solid #eeeeee;
}
.doclist-omit{
  width: 40px;
  height: 40px;
  font-size: 14px;
  color: #999999;
  line-height: 40px;
  text-align: center;
  user-select: none;
}
.doclist-lastpage{
  font-size: 14px;
  color: #666666;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-nextpage{
  font-size: 12px;
  color: #666666;
  margin-right: 34px;
  margin-left: 18px;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-pagejump{
  height: 40px;
  color: #999999;
  font-size: 14px;
  margin-right: 46px;
}
.doclist-pagejump input{
  height: 40px;
  box-sizing: border-box;
  margin-left: 14px;
  margin-right: 8px;
  width: 34px;
  border: 1px solid #e4e4e4;
  text-align: center;
}
.doclist-jump{
  color: #666666;
  font-size: 14px;
  user-select: none;
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid #eeeeee;
  padding: 0 26px;
}
.doclist-lastpage{
  user-select: none;
  cursor: pointer;
}
.doclist-nextpage{
  user-select: none;
  cursor: pointer;
}
.pageDeavtive{
  box-sizing: border-box;
  border: 1px solid #eeeeee;
}
/* 分页区域样式结束 */
.green{
  color: #61ba00;
}
.red{
  color: #bf1b22;
}
.ifNull{
  width:100%;
  text-align:center;
  height:60px;
  font-size:20px;
  line-height:60px;
  }
</style>
